// extracted by mini-css-extract-plugin
export default {"paywallWrapper":"styles_paywallWrapper__Kyb69","buttonBack":"styles_buttonBack__tW7Cw","buttonContent":"styles_buttonContent__60-9G","womanImg":"styles_womanImg__TCDnE"};